import { Component, Input, OnInit } from '@angular/core';
import { CardLinkOffer } from '@fgb/core';

@Component({
  selector: 'fgbcl-card-linking-single-featured-offer',
  templateUrl: './card-linking-single-featured-offer.component.html',
  styleUrls: ['./card-linking-single-featured-offer.component.scss'],
})
export class CardLinkingSingleFeaturedOfferComponent implements OnInit {
  @Input() featuredOffer: CardLinkOffer;
  @Input() currentLcid: string;
  constructor() {}

  ngOnInit(): void {}
}
